export default {"src":"/evde-internet/_next/static/media/chevronLeft.7b74ea6f.svg","height":25,"width":24};